module.exports = __webpack_public_path__ + "img/1673502501669-Screenshot_2023-01-10-16-43-59-444_com.android.chrome.jpg.862d94e5.webp";